module.exports = __webpack_public_path__ + "img/40_38_072_750.87a2c095.jpg";